// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

import Vue from 'vue'
import Router from 'vue-router'

import ApiKeyEdit from '@/views/ApiKeyEdit'
import ApiKeys from '@/views/ApiKeys'
import Dashboard from '@/views/Dashboard'
import EndpointEdit from '@/components/EndpointEdit'
import Endpoints from '@/components/Endpoints'
import Events from '@/components/Events'
import ExceptionDetail from '@/views/ExceptionDetail'
import Index from '@/components/Index'
import Login from '@/components/Login'
import Image from 'photoservice-web/src/components/Image'
import ImageList from 'photoservice-web/src/components/ImageList'
import ImageCategories from 'photoservice-web/src/components/Categories'
import ImageCategoryEdit from 'photoservice-web/src/components/CategoryEdit'
import ImportAsset from '@/views/ImportAsset'
import QRHolder from 'vue-common/components/QRHolder'
import LocationTagEdit from '@/views/LocationTagEdit'
import LocationTags from '@/views/LocationTags'
import MapView from '@/views/Map'
import MapEdit from '@/views/MapEdit'
import Maps from '@/views/Maps'
import OrganizationEdit from '@/views/OrganizationEdit'
import Organizations from '@/views/Organizations'
import OrgSSOSettingsEdit from '@/components/OrgSSOSettingsEdit'
import PasswordResetConfirm from 'vue-common/components/PasswordResetConfirm'
import PasswordResetForm from 'vue-common/components/PasswordResetForm'
import PasswordResetRequest from 'vue-common/components/PasswordResetRequest'
import ReportConfigEdit from '@/views/ReportConfigEdit'
import ReportConfigs from '@/views/ReportConfigs'
import ReportEdit from '@/views/ReportEdit'
import ReportEvents from '@/views/ReportEvents'
import ReportExceptions from '@/views/ReportExceptions'
import ReportZoneDuration from '@/views/ReportZoneDurations'
import ReportZones from '@/views/ReportZones'
import ReportZoneCategories from '@/views/ReportZoneCategories'
import Sites from '@/components/Sites'
import SiteEdit from '@/components/SiteEdit'
import SiteSettings from '@/views/SiteSettings'
import ThingEdit from '@/views/ThingEdit'
import Things from '@/views/Things'
import Users from '@/components/Users'
import UserEdit from '@/views/UserEdit'
import UserMe from '@/components/UserMe'
import ZoneEdit from '@/views/ZoneEdit'
import Zones from '@/views/Zones'

import EndpointAntennas from '@/components/tabs/EndpointAntennas.vue'
// import EndpointConditions from '@/components/tabs/EndpointConditions.vue'
// import EndpointConfig from '@/components/tabs/EndpointConfig.vue'
import EndpointStatus from '@/components/tabs/EndpointStatus.vue'
// import EndpointStatusFB from '@/components/tabs/EndpointStatusFB.vue'
import SiteReportSettings from '@/components/tabs/SiteReportSettings.vue'
import WorkerPhoto from '@/components/tabs/WorkerPhoto.vue'
import ZoneGates from '@/components/tabs/ZoneGates.vue'
import EndpointQRCode from '@/components/tabs/EndpointQRCode.vue'

Vue.use(Router)

Vue.component('endpoint-antennas', EndpointAntennas)
// Vue.component('endpoint-conditions', EndpointConditions)
// Vue.component('endpoint-config', EndpointConfig)
Vue.component('endpoint-status', EndpointStatus)
// Vue.component('endpoint-status-fb', EndpointStatusFB)
Vue.component('endpoint-qrcode', EndpointQRCode)
Vue.component('site-report-settings', SiteReportSettings)
Vue.component('worker-photo', WorkerPhoto)
Vue.component('zone-gates', ZoneGates)
Vue.component('qr-holder', QRHolder)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: 'home',
          component: Dashboard,
          name: 'home'
        },
        {
          path: 'apikeys',
          component: ApiKeys,
          name: 'apikeys'
        },
        {
          path: 'apikeys/:id',
          component: ApiKeyEdit,
          name: 'apikeyEdit'
        },
        {
          path: 'events',
          component: Events,
          name: 'events'
        },
        {
          path: 'exceptions/:id',
          component: ExceptionDetail,
          name: 'exceptionDetail'
        },
        {
          path: 'reports/events',
          component: ReportEvents,
          name: 'reportEvents'
        },
        {
          path: 'reports/exceptions',
          component: ReportExceptions,
          name: 'reportExceptions'
        },
        {
          path: 'reports/zonedurations',
          component: ReportZoneDuration,
          name: 'reportZoneDurations'
        },
        {
          path: 'reports/zonecategories',
          component: ReportZoneCategories,
          name: 'reportZoneCategories'
        },
        {
          path: 'reports/zones',
          component: ReportZones,
          name: 'reportZones'
        },
        {
          path: 'images',
          component: ImageList,
          name: 'images'
        },
        {
          path: '/images/:id',
          name: 'imageEdit',
          component: Image
        },
        {
          path: 'categories',
          component: ImageCategories,
          name: 'categories'
        },
        {
          path: 'categories/:id',
          component: ImageCategoryEdit,
          name: 'categoryEdit'
        },
        {
          path: 'import',
          component: ImportAsset,
          name: 'importAsset'
        },
        {
          path: 'locationtags',
          component: LocationTags,
          name: 'locationtags'
        },
        {
          path: 'locationtags/:id',
          component: LocationTagEdit,
          name: 'locationtagEdit'
        },
        {
          path: 'mapview/:id',
          component: MapView,
          name: 'mapView',
          props: true
        },
        {
          path: 'maps',
          component: Maps,
          name: 'maps'
        },
        {
          path: 'maps/:id',
          component: MapEdit,
          name: 'mapEdit'
        },
        {
          path: 'reports/:id',
          component: ReportEdit,
          name: 'reportEdit'
        },
        {
          path: 'reportconfigs',
          component: ReportConfigs,
          name: 'reportConfigs'
        },
        {
          path: 'reportconfigs/:id',
          component: ReportConfigEdit,
          name: 'reportConfigEdit'
        },
        {
          path: 'endpoints',
          component: Endpoints,
          name: 'endpoints'
        },
        {
          path: 'endpoints/:id',
          component: EndpointEdit,
          name: 'endpointEdit'
        },
        {
          path: 'items',
          component: Things,
          name: 'items'
        },
        {
          path: 'items/:id',
          component: ThingEdit,
          name: 'itemEdit'
        },
        {
          path: 'organizations',
          component: Organizations,
          name: 'organizations'
        },
        {
          path: 'organizations/:id',
          component: OrganizationEdit,
          name: 'organizationEdit'
        },
        {
          path: 'sites',
          component: Sites,
          name: 'sites'
        },
        {
          path: 'sites/:id',
          component: SiteEdit,
          name: 'siteEdit'
        },
        {
          path: 'settings',
          component: SiteSettings,
          name: 'siteSettings'
        },
        {
          path: 'things/:id',
          component: ThingEdit,
          name: 'thingEdit'
        },
        {
          path: 'users',
          component: Users,
          name: 'users'
        },
        {
          path: 'users/:id',
          component: UserEdit,
          name: 'userEdit'
        },
        {
          path: 'userme',
          component: UserMe,
          name: 'userMe'
        },
        {
          path: 'workers',
          component: Things,
          name: 'workers'
        },
        {
          path: 'workers/:id',
          component: ThingEdit,
          name: 'workerEdit'
        },
        {
          path: 'zones',
          component: Zones,
          name: 'zones'
        },
        {
          path: 'zones/:id',
          component: ZoneEdit,
          name: 'zoneEdit'
        },
        {
          path: 'ssosettings',
          component: OrgSSOSettingsEdit,
          name: 'ssoSettings'
        }
      ]
    },
    {
      path: '/login',
      component: Login,
      name: 'login'
    },
    {
      path: '/passwordreset/form',
      component: PasswordResetForm,
      name: 'passwordResetForm'
    },
    {
      path: '/passwordreset/confirm',
      component: PasswordResetConfirm,
      name: 'passwordResetConfirm'
    },
    {
      path: '/passwordreset/request',
      component: PasswordResetRequest,
      name: 'passwordResetRequest'
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js